import moment from "moment";

export const FALLBACK_DATE_FORMAT = "MM-DD-YYYY";

export const displayDate = (date, format = FALLBACK_DATE_FORMAT, currentFormat = null) => {
  try {
    if (!currentFormat) {
      return moment(date).format(format);
    }

    return moment(date, currentFormat).format(format);
  } catch (error) {
    console.log("\nERROR WHILE CONVERTING DATE FORMAT", error);
    return "";
  }
};

export const getWeekdayOccurrence = (startDate, timezone, option) => {
  const date = moment.tz(startDate, timezone);

  const day = date.format("dddd");
  const currentDate = date.format("DD");
  const lastDate = moment.tz(startDate, timezone).endOf("month").format("DD");

  // Get number of times this weekday has occurred so far
  let count = 0;
  // eslint-disable-next-line no-plusplus
  for (let d = 1; d <= date.date(); d++) {
    if (moment.tz([date.year(), date.month(), d], timezone).format("dddd") === day) {
      // eslint-disable-next-line no-plusplus
      count++;
    }
  }

  const suffixes = ["First", "Second", "Third", "Fourth", "Last"];
  const suffix =
    option === "byLastWeekDay" && lastDate - currentDate < 7
      ? "Last"
      : suffixes[count - 1] || suffixes[4];

  return `${suffix} ${day}`;
};
